import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Container } from 'Components/core';
import { layout, colors } from 'Constants';

const NavItem = styled.span`
  position: relative;
  color: ${colors.text};
  transition: 0.2s color;
  cursor: pointer;

  :hover {
    color: ${colors.accent};
  }

  > .dropdown {
    display: none;
  }

  :hover > .dropdown {
    display: flex;
  }
`;

const LinkCustom = styled(Link)`
  text-decoration: none;
`;

const NavDropdown = styled.div`
  position: absolute;
  top: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 350px;
  padding: 16px;
  background: ${colors.background};
  box-shadow: 0 0 10px 0px #aaa;
  
  

  > * {
    padding: 8px 4px;
  }
`;

const HamburgerDropdown = styled(NavDropdown)`
  top: calc(100% );
  width: 100vw;
  left: -16px;
  right: 16px;
  margin-left: 0 !important;
  display: none;
  height:105vh;
  overflow:hidden ;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    display: flex;
  }
`;

const SubCard = styled(Container)`
  padding: 8px;
  background: ${colors.backgroundAlt};
   overflow: scroll;
  > * {
    padding: 8px 4px;
    margin-left: 16px;
  }
`;

// TODO: URL for Logo?
// FIXME: coBrandUrl
export default props => {
  const state = props.state;

  const NavLink = innerProps => (
    <LinkCustom
      to={`${innerProps.to}${location.search}`}
      onClick={() => props.closeHamburger()}
    >
      <NavItem>{innerProps.children}</NavItem>
    </LinkCustom>
  );

  return (
    <HamburgerDropdown id="hamburger"  style={props.style}>
      <Container style={{ justifyContent: 'space-between' }}>
        <NavLink to="/">Home</NavLink>
        <NavItem>
          <NavLink to="/contact_us">Additional Information</NavLink>
        </NavItem>
      </Container>

      <SubCard  column>
        <span style={{ marginLeft: '8px', position: 'relative' }}>
          Benefits
          <svg className="triangle" style={{top:12,position:'absolute'}} height="20" width="20">
            <polygon points="0,0 10,10 20,0" />
          </svg>
        </span>
        {state.includeMedical && (
          <NavLink leaf to="/benefits/medical">
            Medical
          </NavLink>
        )}
        {state.includePharmacy && (
          <NavLink leaf to="/benefits/pharmacy">
            Pharmacy
          </NavLink>
        )}
        {state.includeDental && (
          <NavLink leaf to="/benefits/dental">
            Dental
          </NavLink>
        )}
        {state.includeVision && (
          <NavLink leaf to="/benefits/vision">
            Vision{' '}
          </NavLink>
        )}
        <NavLink leaf to="/benefits/how-plan-works">
          Understanding Healthcare Terms
        </NavLink>

        {state.oeMaterials?.oeBrochure?.oeBrochureURL &&
          (state?.oeMaterials?.oeBrochure?.oeBrochureURL + '').length > 0 && (
            <NavLink leaf to="/benefits/helpful-documents">
              Helpful documents
            </NavLink>
          )}

        {state.includeLifeDisability && (
          <NavLink leaf to="/benefits/life-disability">
            Life and Disability
          </NavLink>
        )}

        {state.includeVoluntary && (
          <NavLink leaf to="/benefits/voluntary">
            Supplemental Health
          </NavLink>
        )}

        {state.includeMoreEnrollmentMaterials && (
          <NavLink leaf to="/benefits/more-materials">
            More Enrollment Materials
          </NavLink>
        )}
        {state.includeBenefitDetails && (
          <NavLink leaf to="/benefits/benefit-details">
           Additional Benefit Information and Resources
          </NavLink>
        )}
        {state.vaInOut && (
          <NavLink leaf to="/benefits/vaInOut">
            The Ins and Outs of Coverage
          </NavLink>
        )}
      </SubCard>

  
   



      {state?.extraMenu?.length > 0 && (
        <SubCard column>
                       <span style={{ marginLeft: '8px', position: 'relative' }}>
          Plan Extras
          <svg className="triangle" style={{top:12,position:'absolute'}} height="20" width="20">
            <polygon points="0,0 10,10 20,0" />
          </svg>
        </span>
                
                    {state?.extraMenu.map(a => {
                      return (
                        <NavLink key={a.code} leaf to={`/plan-extra/${a.code}`}>
                          {a.name}
                        </NavLink>
                      );
                    })}
                  
                  </SubCard>
              )}




      <NavLink to="/find-a-provider">Find a Provider</NavLink>
    </HamburgerDropdown>
  );
};
